module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/poppi-d5b185c79480e66a3b952c18ac1ad3ad.svg";